(function () {
  if (window.StrideScrollReveal) return;

  const ITEM_SELECTOR = '.scroll-trigger.animate--slide-in, .scroll-trigger.animate-headings--slide-in, .scroll-trigger.animate--fade-in, .scroll-trigger.animate-headings--fade-in';
  const ROOT_MARGIN = '0px 0px -50px 0px';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const ROW_TOLERANCE = 4;

  let observer = null;

  function supportsMotion() {
    return !window.matchMedia(REDUCED_MOTION_QUERY).matches;
  }

  function revealItem(item) {
    item.classList.remove('scroll-trigger--offscreen');
  }

  function hideItem(item) {
    item.classList.add('scroll-trigger--offscreen');
  }

  function setCascadeOrder(item, order) {
    if (!item.hasAttribute('data-cascade')) return;
    item.style.setProperty('--animation-order', String(order));
  }

  function getCascadeScope(item) {
    return item.closest('[id^="shopify-section-"]') || item.closest('.shopify-section') || item.parentElement || document.body;
  }

  function assignRowBasedCascadeOrder(scopeItems) {
    const rowAnchors = [];
    const rowCounts = [];

    scopeItems.forEach((item) => {
      if (!item.hasAttribute('data-cascade')) return;

      const itemTop = item.offsetTop;
      let rowIndex = -1;

      for (let index = 0; index < rowAnchors.length; index += 1) {
        if (Math.abs(rowAnchors[index] - itemTop) <= ROW_TOLERANCE) {
          rowIndex = index;
          break;
        }
      }

      if (rowIndex === -1) {
        rowAnchors.push(itemTop);
        rowCounts.push(0);
        rowIndex = rowAnchors.length - 1;
      }

      rowCounts[rowIndex] += 1;
      setCascadeOrder(item, rowCounts[rowIndex]);
    });
  }

  function onIntersection(entries, activeObserver) {
    entries.forEach((entry) => {
      const item = entry.target;

      if (entry.isIntersecting) {
        revealItem(item);
        activeObserver.unobserve(item);
        return;
      }

      hideItem(item);
    });
  }

  function ensureObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;

    observer = new IntersectionObserver(onIntersection, {
      rootMargin: ROOT_MARGIN,
    });

    return observer;
  }

  function initialize(scope, isDesignMode) {
    const items = scope.querySelectorAll(ITEM_SELECTOR);
    if (!items.length) return;

    const allowMotion = supportsMotion();
    const activeObserver = ensureObserver();
    const scopedItems = new Map();

    items.forEach((item) => {
      const cascadeScope = getCascadeScope(item);
      if (!scopedItems.has(cascadeScope)) scopedItems.set(cascadeScope, []);
      scopedItems.get(cascadeScope).push(item);
    });

    scopedItems.forEach((scopeItems) => {
      assignRowBasedCascadeOrder(scopeItems);
    });

    items.forEach((item) => {
      item.classList.add('scroll-trigger--initialized');

      if (isDesignMode || !allowMotion || !activeObserver) {
        item.classList.add('scroll-trigger--design-mode');
        revealItem(item);
        if (activeObserver) activeObserver.unobserve(item);
        return;
      }

      item.classList.remove('scroll-trigger--design-mode');
      hideItem(item);
      activeObserver.observe(item);
    });
  }

  function initAll(isDesignMode) {
    initialize(document, isDesignMode);
  }

  function getEventScope(event) {
    if (!event) return document;

    if (event.detail) {
      if (event.detail.element instanceof Element) return event.detail.element;
      if (event.detail.productInfo instanceof Element) return event.detail.productInfo;
    }

    if (event.target instanceof Element) return event.target;
    return document;
  }

  function handleDynamicContent(event) {
    initialize(getEventScope(event), Boolean(window.Shopify && window.Shopify.designMode));
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(Boolean(window.Shopify && window.Shopify.designMode));
  });

  document.addEventListener('product-recommendations:loaded', handleDynamicContent);
  document.addEventListener('product-info:loaded', handleDynamicContent);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initialize(event.target, true);
    });

    document.addEventListener('shopify:section:reorder', function () {
      initAll(true);
    });
  }

  window.StrideScrollReveal = {
    init: initAll,
  };
})();
